/**
 * Прив’язка полів модуля «automation» до понять довідника (значок «?» біля підпису поля).
 * Ключ — `automation.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary), напр. 'КЦ', 'ЦА'.
 * Мапу підключено в features/knowledge/fieldTerms.ts (FIELD_TERMS). Поле в інтерфейсі: <Field term="automation.<сутність>.<поле>">.
 */
export const AUTOMATION_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Тригер «Задачу прострочено»: контрольний час фіксації «червоних» задач.
  'automation.trigger.notBeforeHour': 'Червона задача',
  // Отримувачі: учасники задачі з бізнес-ролями (напр. КМ замовлення).
  'automation.recipients.followerRoles': 'Фоловер',
};
